// TODO: return string as formatted kilometers to keep format consistent across app
export const toKilometers = (meters: number) => {
  return Math.round(meters / 1000);
};
